<script>
  import Layout from '/components/Layout.svelte';
  import { inertia } from '@inertiajs/svelte';

  export let events = [];
</script>

<svelte:head>
  <title>Manual Events — Age of Trevor Webedit</title>
</svelte:head>

<Layout title="Manual Events">
  <div class="toolbar">
    <a use:inertia href="/" class="back-link">← Dashboard</a>
    <a use:inertia href="/event_views/orphans" class="sibling-link">Orphans →</a>
  </div>

  <p class="summary">
    Events with <code>trigger_type: manual</code> — only reachable via
    <code>trigger_event</code> or <code>schedule_event</code> effects.
  </p>

  <div class="file-count">{events.length} {events.length === 1 ? 'event' : 'events'}</div>

  {#if events.length === 0}
    <p class="empty">No manual events found.</p>
  {:else}
    <ul class="event-list">
      {#each events as event}
        <li>
          <a use:inertia href="/editor/events/{event.relative_path}" class="event-link">
            <span class="event-id">{event.id}</span>
            {#if event.title && event.title !== event.id}
              <span class="event-title">{event.title}</span>
            {/if}
            <span class="event-path">{event.relative_path}.yml</span>
          </a>
        </li>
      {/each}
    </ul>
  {/if}
</Layout>

<style>
  .toolbar {
    display: flex;
    justify-content: space-between;
    margin-bottom: 1.5rem;
  }

  .back-link, .sibling-link {
    color: #64748b;
    text-decoration: none;
    font-size: 0.9rem;
  }

  .back-link:hover, .sibling-link:hover { color: #1e293b; }

  .summary {
    font-size: 0.9rem;
    color: #64748b;
    margin: 0 0 1.25rem 0;
  }

  code {
    font-family: 'Fira Code', monospace;
    background: #f1f5f9;
    padding: 0.1em 0.35em;
    border-radius: 0.25rem;
    font-size: 0.85em;
    color: #1e3a8a;
  }

  .file-count {
    font-size: 0.8rem;
    color: #94a3b8;
    margin-bottom: 0.75rem;
  }

  .empty {
    color: #94a3b8;
    font-style: italic;
  }

  .event-list {
    list-style: none;
    padding: 0;
    margin: 0;
    display: flex;
    flex-direction: column;
    gap: 0.25rem;
  }

  .event-link {
    display: grid;
    grid-template-columns: auto 1fr auto;
    align-items: baseline;
    gap: 0.75rem;
    padding: 0.6rem 0.875rem;
    text-decoration: none;
    background: #f8fafc;
    border: 1px solid #e2e8f0;
    border-radius: 0.5rem;
    transition: background 0.15s, border-color 0.15s;
  }

  .event-link:hover {
    background: #eff6ff;
    border-color: #93c5fd;
  }

  .event-id {
    font-family: 'Fira Code', monospace;
    font-size: 0.875rem;
    font-weight: 600;
    color: #1d4ed8;
    white-space: nowrap;
  }

  .event-title {
    font-size: 0.875rem;
    color: #475569;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .event-path {
    font-family: 'Fira Code', monospace;
    font-size: 0.775rem;
    color: #94a3b8;
    white-space: nowrap;
    justify-self: end;
  }
</style>
